import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';
import menuItem from 'assets/Images/menuItem.svg';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  text-transform:  ${props => props.theme.textTransform || 'none'};
  padding: ${props => props.theme.padding.default};

  ${Media.lg`
    padding: ${props => props.theme.padding.lg || 0};
  `}

  ${props =>
    props.theme &&
    props.theme.position &&
    props.theme.position === 'bottom-center-edge' &&
    css`
      margin-bottom: ${props => props.theme.marginBottom || '-55px'};

      ${Media.lg`
        margin-bottom: initial;
      `}
    `}

    ${props =>
      props.theme &&
      props.theme.background &&
      css`
        background: ${props => props.theme.background.default};

        ${Media.lg`
        background: ${props => props.theme.background.lg};
      `}
      `}

      ${props =>
        props.theme &&
        props.theme.borderRadius &&
        css`
          border-radius: ${props => props.theme.borderRadius.default};

          ${Media.lg`
        border-radius: ${props => props.theme.borderRadius.lg};
      `}
        `}

    ${props =>
      props.theme.shape &&
      css`
        .shape {
          position: absolute;
          display: block;
          top: -10px;
          left: -15px;
          right: -15px;
          bottom: -25px;
          z-index: -1;

          svg {
            width: 100%;
            height: 100%;

            path {
              fill: ${props => props.theme.shapeBackground};
            }
          }
          ${Media.lg`
            display: none;
          `}
        }
      `}
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: ${props => props.theme.justifyContent || 'normal'};
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  & > div:after {
    display: block;
    ${Media.lg`
      display: none;
    `}
  }
  ${Media.lg`
    display: none;
    margin: 0;
  `}

  ${props =>
    props.theme &&
    props.theme.position &&
    props.theme.position === 'bottom-center-edge' &&
    css`
      min-height: ${props => props.theme.minHeight || '80px'};
      align-items: ${props => props.theme.alignItems || 'stretch'};
      ${Media.lg`
        min-height: initial;
      `};
    `}

  ${props =>
    props.toggle &&
    css`
      ${Media.lg`
        display: flex;
      `}
    `}
`;

export const Item = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: ${props => props.theme.flexDirection || 'column'};
  align-items: ${props => props.theme.alignItems || 'stretch'};
  ${Media.lg`
    display: block;
    width: 100%;
  `}

  ${props =>
    props.isSubmenu &&
    css`
      width: 100%;
    `}

  ${props =>
    props.isMegamenu &&
    css`
      position: initial;
    `}
  &:last-child:after{
    display: none;
  }
  &:after {
    display: none;
    font-family: MONOSPACE;
    content: '${props =>
      props.theme.afterContent ? `${props.theme.afterContent} ` : ''}';
    color:  ${props => props.theme.afterColor};
    font-size: ${props => `${props.theme.afterFontSize}rem`};
    ${Media.md`
      display: none;
    `}
  }
  font-weight:600;
   ${props =>
     props.isSubmenu &&
     props.theme.evenBackground &&
     css`
       &:nth-child(2n) {
         background: ${props.theme.evenBackground};
       }
     `}   
`;

export const Link = styled(RouterLink)`
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: ${props => props.theme.minHeight.default};
  padding: ${props => props.theme.padding.default};
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  border-bottom: ${props => props.theme.borderBottomOnNormal || 'none'};
  cursor: pointer;
  
  ${Media.lg`
    min-height: ${props => props.theme.minHeight.lg};
    padding: ${props => props.theme.padding.lg};
    border-top: 1px solid ${props => props.theme.border};
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
    background: ${props =>
      props.theme.backgroundOnMobile || props.theme.background || 'transparent'}
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  &:last-of-type {
    ${Media.lg`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }
  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
      box-shadow: ${props => props.theme.boxShadowOnActive};
      border-bottom: ${props => props.theme.borderBottomOnActive || 'none'};
      border-color: ${props => props.theme.borderBottomOnActiveColor};
    `}

  &:hover {
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
    box-shadow: ${props => props.theme.boxShadowOnHover};
    ${Media.md`
      background-color: ${props =>
        props.theme.backgroundOnHoverMd || props.theme.backgroundOnHover};
      box-shadow: ${props =>
        props.theme.boxShadowOnHoverMd || props.theme.boxShadowOnHover};

    `}
  }

  ${props =>
    props.opened &&
    css`
      color: ${props => props.theme.colorOnHover};
      background: ${props => props.theme.backgroundOnHover};
      box-shadow: ${props => props.theme.boxShadowOnHover};
      ${Media.md`
      background-color: ${props => props.theme.backgroundOnHoverMd};
      box-shadow: ${props => props.theme.boxShadowOnHoverMd};

    `}
    `}

    ${props =>
      props.cardBackground &&
      css`
        margin: ${props => props.theme.margin || '0'};
        width: ${props => props.theme.width || 'auto'};
        filter: drop-shadow(0 0 1rem #66666630);
        background-image: url(${menuItem});
        background-repeat: no-repeat;
        background-size: cover;

        &:hover {
          margin: ${props => props.theme.marginOnHover || '0'};
          min-height: ${props => props.theme.minHeight.defaultOnHover};
          text-decoration: none;
        }
        ${Media.lg`
        background-image: none;
        margin: 0;
        width: 100%;
        filter: none;
        &:hover {
          min-height: ${props => props.theme.minHeight.lgOnHover};
          margin:  ${props => props.theme.marginLgOnHover || '0'};
        }


      `}
      `}

    ${props =>
      props.theme.border &&
      css`
        border-bottom: 2px solid transparent;
      `} 

    &:hover{
      border-bottom: 2px solid red;
      ${props =>
        props.theme.border &&
        css`
          border-bottom: 2px solid ${props.theme.border};
        `}    
    }       
`;
export const LinkExternal = styled.a`
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: ${props => props.theme.minHeight.default};
  padding: ${props => props.theme.padding.default};
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  border-bottom: ${props => props.theme.borderBottomOnNormal || 'none'};
  cursor: pointer;

  ${Media.lg`
    min-height: ${props => props.theme.minHeight.lg};
    padding: ${props => props.theme.padding.lg};
    border-top: 1px solid ${props => props.theme.border};
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
  &:last-of-type {
    ${Media.lg`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
      box-shadow: ${props => props.theme.boxShadowOnActive};
      border-bottom: ${props => props.theme.borderBottomOnActive || 'none'};
    `}

  &:hover {
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
    box-shadow: ${props => props.theme.boxShadowOnHover};
    ${Media.md`
      background-color: ${props => props.theme.backgroundOnHoverMd};
    `}
  }

  ${props =>
    props.opened &&
    css`
      color: ${props => props.theme.colorOnHover};
      background: ${props => props.theme.backgroundOnHover};
      box-shadow: ${props => props.theme.boxShadowOnHover};
      ${Media.md`
      background-color: ${props =>
        props.theme.backgroundOnHoverMd || props.theme.backgroundOnHover};
    `}
    `}
    ${props =>
      props.cardBackground &&
      css`
        margin: ${props => props.theme.margin || '0'};
        width: ${props => props.theme.width || 'auto'};
        filter: drop-shadow(0 0 1rem #66666630);
        background-image: url(${menuItem});
        background-repeat: no-repeat;
        background-size: cover;

        &:hover {
          margin: ${props => props.theme.marginOnHover || '0'};
          min-height: ${props => props.theme.minHeight.defaultOnHover};
          text-decoration: none;
        }
        ${Media.lg`
        background-image: none;
        margin: 0;
        width: 100%;
        filter: none;

        &:hover {
          min-height: ${props => props.theme.minHeight.lgOnHover};
          margin:  ${props => props.theme.marginLgOnHover || '0'};
        }
      `}
      `}
      ${props =>
        props.theme.border &&
        css`
          border-bottom: 2px solid transparent;
        `} 

    &:hover{
      border-bottom: 2px solid red;
      ${props =>
        props.theme.border &&
        css`
          border-bottom: 2px solid ${props.theme.border};
        `}          
`;

export const Option = styled.span`
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-height: ${props => props.theme.minHeight.default};
  padding:  ${props => props.theme.padding.default};
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: pointer;

  ${Media.lg`
    min-height: ${props => props.theme.minHeight.lg};
    padding: ${props => props.theme.padding.lg};
    border-top: 1px solid ${props => props.theme.border};
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  ${props =>
    props.theme &&
    props.theme.borderRadius &&
    css`
      border-top-right-radius: ${props => props.theme.borderRadius.default};
      border-top-left-radius: ${props => props.theme.borderRadius.default};

      ${Media.lg`
        border-top-right-radius: ${props => props.theme.borderRadius.lg};
        border-top-left-radius: ${props => props.theme.borderRadius.lg};
      `}
    `}

  &:last-of-type {
    ${Media.lg`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
      box-shadow: ${props => props.theme.boxShadowOnActive};
    `}

  &:hover {
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
    box-shadow: ${props => props.theme.boxShadowOnHover};
    ${Media.md`
      background-color: ${props => props.theme.backgroundOnHoverMd};
    `}
  }

  ${props =>
    props.opened &&
    css`
      color: ${props => props.theme.colorOnHover};
      background: ${props => props.theme.backgroundOnHover};
      box-shadow: ${props => props.theme.boxShadowOnHover};
      ${Media.md`
      background-color: ${props => props.theme.backgroundOnHoverMd};
    `}
    `}

`;

export const ItemContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  width: 200px;
  margin-top: -1px;
  background: ${props => props.theme.background.default};
  box-shadow: ${props => props.theme.boxShadow};
  z-index: +2;

  ${Media.lg`
    position: relative;
    top: initial;
    left: initial;
    width: 100%;
    margin-top: initial;
    box-shadow: none;
    z-index: initial;
    background: ${props => props.theme.background.lg};
  `}


  ${props =>
    props.isSubmenu &&
    css`
      top: 0;
      left: 100%;
      margin-top: initial;

      ${Media.lg`
        top: initial;
        left: initial;
      `}
    `}


  ${props =>
    props.opened &&
    css`
      display: block;
    `}

    ${props =>
      props.leftSideDisplay &&
      css`
        left: initial;
        right: 0;

        ${props =>
          props.isSubmenu &&
          css`
            left: initial;
            right: 100%;

            ${Media.lg`
              right: initial;
            `}
          `}

        ${Media.lg`
          right: initial;
        `}
      `}
`;

export const Arrow = styled.i`
  display: none;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 5px;
  color: ${props => props.theme.color};
  vertical-align: middle;
  transition: .2s all;

  ${Media.lg`
    display: inline-flex
  `}

  ${props =>
    props.isSubmenu &&
    css`
      display: inline-flex;
    `}

  ${Link}:hover > &,
  ${LinkExternal}:hover > &,
  ${Option}:hover > & {
    color: ${props => props.theme.colorOnHover};
  }
`;
